import * as React from "react";
import type { SVGProps } from "react";
const SvgDotsMenuNew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={3}
    fill="none"
    viewBox="0 0 16 3" {...props}
  >
    <path
      fill="#323232"
      d="M13.987.257a1.25 1.25 0 1 1-1.37 1.37l-.008-.127.007-.128A1.25 1.25 0 0 1 13.86.25zM7.985.257a1.25 1.25 0 1 1-1.371 1.37L6.607 1.5l.007-.128A1.25 1.25 0 0 1 7.857.25zM1.982.257a1.25 1.25 0 1 1-1.37 1.37L.603 1.5l.007-.128A1.25 1.25 0 0 1 1.854.25z"
    />
  </svg>
);
export default SvgDotsMenuNew;
